import "./index.scss";
import arrow from "../../../images/arrow.png";
import Button from "../../Button";

const Contact = () => {
  return (
    <div className="Contact view">
      <section>
        <div className="section-title">
          <img src={arrow} />
          Contact
          <div className="line" />
        </div>
        <div className="section-content">
          <p>
            If you have any questions or just want to say hello, send me an e-mail and I&apos;ll get back to you as soon as possible!
          </p>
          <div className="links">
            <a className="button" href="mailto:regina.sirilan@hotmail.com">
              <Button text="Say Hello" />
            </a>
            <div className="icons">
              <a href="https://github.com/ahhreggi" target="_blank" rel="noreferrer">
                <i className="fa fa-github"></i>
              </a>
              <a href="https://www.linkedin.com/in/ahhreggi/" target="_blank" rel="noreferrer">
                <i className="fa fa-linkedin"></i>
              </a>
              {/* <a href="https://twitter.com/ahhreggi/" target="_blank" rel="noreferrer">
                <i className="fa fa-twitter"></i>
              </a>
              <a href="https://www.twitch.tv/ahhreggi" target="_blank" rel="noreferrer">
                <i className="fa fa-twitch"></i>
              </a> */}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;